import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      return setError('Las contraseñas no coinciden');
    }
    if (newPassword.length < 8) {
      return setError('La contraseña debe tener al menos 8 caracteres');
    }

    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/api/auth/reset-password`, { token, newPassword });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.message || 'El enlace es inválido o ha expirado');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="login-container">
        <div className="login-image"></div>
        <div className="login-form-container">
          <div className="login-form">
            <p style={{ color: 'red' }}>Enlace inválido.</p>
            <Link to="/forgot-password" style={{ color: '#4f46e5' }}>Solicitar nuevo enlace</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-image"></div>
      <div className="login-form-container">
        <form onSubmit={handleSubmit} className="login-form">
          <h2><span className="taxi-highlight">TⒶXí</span> te lleva al futuro de la contabilidad</h2>
          <p>Crear nueva contraseña</p>

          {success ? (
            <div style={{ textAlign: 'center' }}>
              <p style={{ color: '#4f46e5', marginBottom: '16px' }}>
                ¡Contraseña actualizada correctamente!
              </p>
              <Link to="/login" style={{ display: 'block', marginTop: '8px', color: '#4f46e5' }}>
                Ir al login
              </Link>
            </div>
          ) : (
            <>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Nueva contraseña (mín. 8 caracteres)"
                required
              />
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirmar contraseña"
                required
              />
              {error && <p style={{ color: 'red', fontSize: '13px' }}>{error}</p>}
              <button type="submit" disabled={loading}>
                {loading ? 'Guardando...' : 'Guardar nueva contraseña'}
              </button>
            </>
          )}
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
